import apiConfig from '@constants/apiConfig';

import DeviceRequestListPage from '.';

export default {
    deviceRequestListPage: {
        path: '/device-request',
        title: 'Digibes request',
        auth: true,
        component: DeviceRequestListPage,
        // permission: [apiConfig.deviceRequest.getList.baseURL],
    },
};
